export default {
  infobip_accounts: [],
  infobip_account: [],
  active_infobip_account: [],
};
